import { accountAPI } from 'services';
import MonthView from './MonthView';
import useOffcanvasStore from 'store/offcanvasStore';
import useUniversalStore from 'store/universalStore';

const Header = ({ account, setAnimation, hideCancelled, handleToggle, goBack }) => {
  const { openOffcanvas } = useOffcanvasStore();
  const { txnViewMode, setTxnViewMode } = useUniversalStore((state) => state);
  const isSharedAccount = accountAPI.checkIsSharedAccount(account);

  const headerClass = isSharedAccount ? "bg-app-accent" : "";
  const accountName = account.get("name");

  return (
    <div className={`py-2 d-flex align-items-center flex-wrap px-2 shadow-sm bg-light ${headerClass}`}>
      <div className="col-12 col-md-9 d-flex align-items-center px-2" align="left">
        <i className="bi bi-arrow-left fs-3 me-2 me-md-3 d-md-none cursor-pointer"
          onClick={goBack}></i>
        <div className='d-flex align-items-center' onClick={() => openOffcanvas('editAccount')}>
          {account?.get("photo") ? (
            <img
              src={account.get("photo")}
              className="profile-img my-1 my-md-2 cursor-pointer border border-2 border-danger"
              onError={(e) => {
                e.target.src = "https://placehold.co/150x150";
              }} />
          ) : (
            <i className="bi bi-person-circle text-app"
              style={{ fontSize: "40px" }} />
          )}

          <div className="mx-2 ms-md-4 cursor-pointer">
            <span className='fs-5 fs-md-4 d-block lh-1 text-truncate'>{accountName}
              {isSharedAccount && <span className="ms-2 badge rounded-pill text-bg-danger fs-6">Shared</span>}
            </span>
            <span className="fw-normal d-block" style={{ fontSize: "10px" }}>
              <i>View Profile</i>
            </span>
          </div>
        </div>
        <div className="btn-group btn-group-sm" role="group" aria-label="Transaction View Mode">
          <button
            type="button"
            className={`btn ${txnViewMode === "t-view" ? "btn-app" : "btn-outline-app"}`}
            onClick={() => setTxnViewMode?.("t-view")}
            title="T-View (2-column layout)"
          >
            <i className="bi bi-layout-split me-1 d-inline d-sm-none" />
            <span className="d-none d-sm-inline">Khata</span>
          </button>
          <button
            type="button"
            className={`btn ${txnViewMode === "table" ? "btn-app" : "btn-outline-app"}`}
            onClick={() => setTxnViewMode?.("table")}
            title="Statement Table View"
          >
            <i className="bi bi-table me-1 d-inline d-sm-none" />
            <span className="d-none d-sm-inline">Statement</span>
          </button>
        </div>
        <div className='mt-1 ms-auto me-md-3 d-flex align-items-center gap-2' align="right">
          <i className={`fs-3 fs-md-2 text-app cursor-pointer ${hideCancelled ? "bi-filter-circle-fill" : "bi-filter"}`}
            title={hideCancelled ? "Showing active transactions only" : "Showing all transactions"}
            onClick={() => handleToggle(!hideCancelled)}></i>
        </div>
      </div>
      <div className='col-12 col-md-3 px-2 d-flex justify-content-between align-items-center'>
        <MonthView
          setAnimation={setAnimation}
        />
      </div>
    </div>
  )
}

export default Header;